import { createFileRoute } from '@tanstack/react-router'

import { TransactionScoringScreen } from './-components/transaction-scoring-screen.tsx'

export const Route = createFileRoute('/risk/transaction-scoring')({
  component: TransactionScoringScreen
})
